import { Component, ElementRef, Input, OnDestroy, SimpleChanges, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Subject } from 'rxjs';

@Component({
  selector: 'nc-video-easy',
  templateUrl: './video-easy.component.html',
  styleUrls: ['./video-easy.component.less']
})
export class VideoEasyComponent implements AfterViewInit, OnDestroy {
  /** 返回播放状态 */
  @Output() ncPlaying = new EventEmitter<boolean>();
  /** 返回播放器 */
  @Output() ncLoaded = new EventEmitter<any>();

  /** 视频地址 */
  @Input() ncUrl: string = '';
  /** 超时 */
  @Input() ncTimeout: number = 10;
  /** 播放失败文案 */
  @Input() ncErrorText: string = '播放失败';
  /** 播放超时文案 */
  @Input() ncTimeoutText: string = '播放超时，视频源无响应';
  /** 静音 */
  private _muted: boolean = true;
  @Input() set ncMuted(value: boolean | string) {
    this._muted = value !== null && value !== undefined && value !== false && value !== 'false';
  }
  get ncMuted() {
    return this._muted;
  }
  /** 自动播放 */
  private _autoplay: boolean = false;
  @Input() set ncAutoplay(value: boolean | string) {
    this._autoplay = value !== null && value !== undefined && value !== false && value !== 'false';
  }
  get ncAutoplay() {
    return this._autoplay;
  }

  viewerUrl!: SafeResourceUrl;
  private messageListener: ((event: MessageEvent) => void) | null = null;
  private errorSubject = new Subject<any>();
  private iframeElement: HTMLIFrameElement | null = null;
  private playerController: any = null;
  private uniqueId: string;

  constructor(private eleRef: ElementRef, private sanitizer: DomSanitizer) {
    // 生成唯一ID
    this.uniqueId = `video_easy_${Math.random().toString(36).substring(2, 11)}`;
    // 监听消息
    this.messageListener = (event: MessageEvent) => {
      if (event.data && event.data.type === 'iframe-message') {
        const eventData: any = event.data;
        //只处理当前视频iframe的消息
        //防止一次用几个组件，其中一个iframe发消息，所有组件都收到
        if (eventData.uniqueId != this.uniqueId) {
          return;
        }
        this.errorSubject.next(eventData);
        if (eventData.message == 'play') {
          this.ncPlaying.emit(true);
        } else if (eventData.message == 'pause') {
          this.ncPlaying.emit(false);
        } else if (eventData.message == 'loaded') {
          this.playerController = {
            pause: () => {
              this.sendCommandToIframe('pause');
            },
            play: (url: string) => {
              this.sendCommandToIframe('play', url);
            },
            setMute: (mute: boolean) => {
              this.sendCommandToIframe('setMute', mute);
            },
            destroy: () => {
              this.sendCommandToIframe('destroy');
            }
          }
          this.ncLoaded.emit(this.playerController);
        }
      }
    };

    window.addEventListener('message', this.messageListener);
  }

  ngAfterViewInit(): void {
    // 获取 iframe 元素
    const iframe = this.eleRef.nativeElement.querySelector('iframe');
    if (iframe) {
      this.iframeElement = iframe;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['ncUrl']) {
      this.updateVideoUrl();
    }
  }

  ngOnDestroy(): void {
    this.sendCommandToIframe('destroy');
  }

  private updateVideoUrl() {
    const iframeUrl = `assets/easyplayer-js/viewer.html?url=${encodeURIComponent(this.ncUrl)}&autoplay=${this.ncAutoplay}&muted=${this.ncMuted}&uniqueId=${this.uniqueId}&timeout=${this.ncTimeout}&errorText=${this.ncErrorText}&timeoutText=${this.ncTimeoutText}`;
    this.viewerUrl = this.sanitizer.bypassSecurityTrustResourceUrl(iframeUrl);
  }

  private sendCommandToIframe(command: string, params?: any) {
    if (this.iframeElement && this.iframeElement.contentWindow) {
      const message = {
        type: 'player-command',
        command: command,
        params: params
      };
      this.iframeElement.contentWindow.postMessage(message, '*');
    }
  }
}
